// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n6-1";
export var messageSideRight = "_n6-2";
export var orderLookupBubbleContainer = "_n6-0";
export var submitButton = "_n6-3";